import React from 'react';

interface LoadingIndicatorProps {
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message = 'Loading data...' }) => {
  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
      <div className="loading-message">{message}</div>
    </div>
  );
};

export default LoadingIndicator;
